import _Number$parseInt from 'babel-runtime/core-js/number/parse-int';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _extends from 'babel-runtime/helpers/extends';

import { mapActions } from 'vuex';

var KeyframeType = {
  AUTO: 0,
  FREE_SMOOTH: 1,
  FLAT: 2,
  BROKEN: 3,
  LINEAR: 4
};

var CurveType = {
  default: 1,
  'animation-manager-editor-tween-absolute': 11
};

var config = {
  curveType: 1,
  startX: 100,
  startY: 400,
  endX: 400,
  endY: 100,
  tLen: 0,
  handlePointLen: 50,
  allowMoveLine: false,
  drawControlPoint: false,
  drawHandlePoint: false,
  drawDirectPoint: true,
  coordinate: {
    lineWidth: 1,
    lineColor: '#eeeeee',
    mainLineWidth: 1,
    mainLineColor: '#cccccc',
    fontStyle: '18px bold arial',
    fontColor: '#666666'
  },
  round: {
    curve: { width: 2, color: '#FAC415' }, // 曲线颜色
    cpline: { width: 0.5, color: '#AF7B0F' }, // 切线颜色
    handleline: { width: 0.5, color: '#FAB015' }, // 切线颜色
    point: {
      radius: 5,
      width: 1,
      handleRadius: 3,
      selectedColor: '#AF7B0F',
      handleColor: '#ff00ff',
      controlPointColor: 'red',
      drawHandleColor: '#AF9C0F',
      color: '#AF7B0F', // 操作点描边颜色
      fill: '#ffffff' // 操作点填充颜色
    }
  }
};

export default {
  props: ['width', 'height', 'initCurveValue'],

  watch: {
    initCurveValue: function initCurveValue(curveValue) {
      this.value = this.transformValue(curveValue);
      this.drawValueCanvas();
    }
  },

  created: function created() {
    this.value = this.transformValue(this.initCurveValue);
    setTimeout(this.drawValueCanvas, 300);
  },
  data: function data() {
    return {
      value: this.initCurveValue,
      valueTransformer: {
        scaleX: 1,
        scaleY: 1,
        offsetX: 0,
        offsetY: 0
      },
      curveTemplateValues: [[[0, 0, 0, 0], [1, 0, 0, 0]], [[0, 0, 1, 1], [1, 1, 1, 1]], [[0, 0, 0.5, 0.5], [1, 1, 2, 2]], [[0, 0, 2, 2], [1, 1, 0.5, 0.5]], [[0, 0, 1, 1], [1, 0, 1, 1]], [[0, 0, 0, 0], [1, 1, 0, 0]]],
      customCurveDialogProps: {
        saveCurveName: '',
        visible: false,
        modalAppendToBody: true,
        appendToBody: true
      },
      customCurveTemplateValues: [],
      curveDatas: {},
      currentPage: 1,
      pageSize: 12,
      dialogProps: {
        visible: false,
        title: this.$t('workbench.animation.curveEditor.dialogProps.title'),
        modalAppendToBody: true,
        appendToBody: true,
        modal: true,
        width: '800px',
        closeOnPressEscape: false,
        closeOnClickModal: false
      },
      mainCurveWidth: 0,
      mainCurveHeight: 0,
      ctx: null,
      mainCurveCanvas: null,
      lineSet: [],
      clickPoint: null,
      clickPointType: null,
      selectedPoint: null,
      onLineSet: 0,
      sourcePoint: null,
      CurrentPoints: []
      /**
       *
       {
        keyframeType:KeyframeType.FREE_SMOOTH,
        x:150,
        y:150,
        icx:300, //in control point
        icy:100,
        ocx:100, //out control point
        ocy:100,
        hix: 0,
        hiy: 0,
        hox: 0,
        hoy: 0,
        dix: 0,
        diy: 0,
        dox: 0,
        doy: 0
      }
       */
    };
  },


  methods: _extends({}, mapActions({
    getCustomCurve: 'workspace/resource/getCustomCurve',
    deleteCustomCurve: 'workspace/resource/deleteCustomCurve',
    saveCustomCurve: 'workspace/resource/saveCustomCurve'
  }), {
    transformValue: function transformValue(data) {
      var _this = this;

      var newData = [];
      if (data.dataFrom === 'animation-manager-editor-tween-absolute') {
        config.curveType = CurveType[data.dataFrom];
        var minX = data[0][0];
        var minY = data[0][1];
        var maxX = data[0][0];
        var maxY = data[0][1];
        data.forEach(function (item, index) {
          if (item[0] > maxX) maxX = item[0];
          if (item[1] > maxY) maxY = item[1];
          if (item[0] < minX) minX = item[0];
          if (item[1] < minY) minY = item[1];
        });
        this.valueTransformer.scaleX = maxX === minX ? 1 : maxX - minX;
        this.valueTransformer.scaleY = maxY === minY ? 1 : maxY - minY;
        this.valueTransformer.offsetX = minX;
        this.valueTransformer.offsetY = minY;
        data.forEach(function (item, index) {
          var newTime = (item[0] - minX) / (maxX - minX);
          var newValue = (item[1] - minY) / (maxY - minY);
          var newInTangent = item[2] * (_this.valueTransformer.scaleX / _this.valueTransformer.scaleY);
          var newOutTangent = item[3] * (_this.valueTransformer.scaleX / _this.valueTransformer.scaleY);
          newData.push([isNaN(newTime) ? 0 : newTime, isNaN(newValue) ? 0 : newValue, newInTangent, newOutTangent]);
        });
      } else {
        newData.push.apply(newData, _toConsumableArray(data));
      }
      while (newData.length < 2) {
        if (newData[0]) {
          newData.push(newData[0]);
        } else {
          newData.push([0, 0, 0, 0]);
        }
      }
      return newData;
    },
    deleteCurve: function deleteCurve(_ref) {
      var _this2 = this;

      var id = _ref.id;

      this.deleteCustomCurve({ id: id }).then(function (res) {
        if (res.code === 0) {
          _this2.updateCustomCurveTemplate();
        }
      });
    },
    saveCurrentCurve: function saveCurrentCurve() {
      this.customCurveDialogProps.visible = true;
    },
    saveCurve: function saveCurve() {
      var _this3 = this;

      if (this.customCurveDialogProps.saveCurveName === '') {
        this.$editMessage.error(this.$t('workbench.animation.curveEditor.curveNameIsEmpty'));
        return;
      }
      this.saveCustomCurve({
        name: this.customCurveDialogProps.saveCurveName,
        data: _JSON$stringify(this.value),
        type: config.curveType
      }).then(function (res) {
        _this3.customCurveDialogProps.visible = false;
        _this3.updateCustomCurveTemplate(Math.ceil(_this3.curveDatas.total / _this3.pageSize));
      });
    },
    openDialog: function openDialog() {
      this.dialogProps.visible = true;
      setTimeout(this.initCurve, 300);
    },
    closeDialog: function closeDialog() {
      this.dialogProps.visible = false;
    },


    /**
     * @TODO 为以后解决全局保存数据问题，主要用于更新父节点的的fromValue传值,当只点击了保存，未全局保存数据丢失
     */
    save: function save() {
      // this.value 是曲线渲染数据，数组类型
      this.$emit('save', {
        keyframes: this.value,
        valueTransformer: this.valueTransformer
      });
      this.drawValueCanvas();
      this.$editMessage({
        message: this.$t('workbench.animation.curveEditor.saveCurveSuccess'),
        type: 'success'
      });
      this.closeDialog();
    },
    initCurve: function initCurve() {
      this.mainCurveCanvas = this.$refs['main-curve'];
      this.ctx = this.mainCurveCanvas.getContext('2d');
      this.mainCurveWidth = this.mainCurveCanvas.parentElement.clientWidth;
      this.mainCurveHeight = this.mainCurveCanvas.parentElement.clientHeight;
      this.mainCurveCanvas.setAttribute('width', this.mainCurveWidth);
      this.mainCurveCanvas.setAttribute('height', this.mainCurveHeight);
      this.setUpCanvas(this.mainCurveWidth, this.mainCurveHeight);
      this.initCurveEditor(this.value);
      this.getBezierSet();
      this.ctx.lineCap = 'round';
      this.ctx.lineJoin = 'round';
      this.drawCurve();
      this.initCurveTemplate();
    },
    initCurveEditor: function initCurveEditor(data) {
      this.CurrentPoints = [];
      var tLen = config.endX - config.startX; // 起点到终点的x轴距离默认为1个完整单位tLen
      config.tLen = tLen;
      for (var i = 0; i < data.length; i++) {
        var iTLen = void 0,
            oTLen = void 0;
        if (i === 0) {
          iTLen = (config.endX - config.startX) * (data[1][0] - data[0][0]);
          oTLen = (config.endX - config.startX) * (data[1][0] - data[0][0]);
        } else if (i === data.length - 1) {
          iTLen = (config.endX - config.startX) * (data[i][0] - data[i - 1][0]);
          oTLen = (config.endX - config.startX) * (data[i][0] - data[i - 1][0]);
        } else {
          iTLen = (config.endX - config.startX) * (data[i][0] - data[i - 1][0]);
          oTLen = (config.endX - config.startX) * (data[i + 1][0] - data[i][0]);
        }
        var point = this.getCurvePoint(data[i], iTLen, oTLen);
        this.CurrentPoints.push(point);
      }
      if (!(this.CurrentPoints[0].ocx - this.CurrentPoints[0].x > 0 && this.CurrentPoints[this.CurrentPoints.length - 1].icx - this.CurrentPoints[this.CurrentPoints.length - 1].x < 0)) {
        var startCP = this.CurrentPoints[0];
        var tempStartCP = {
          ocx: startCP.ocx,
          ocy: startCP.ocy,
          icx: startCP.icx,
          icy: startCP.icy
        };
        startCP.ocx = tempStartCP.icx;
        startCP.ocy = tempStartCP.icy;
        startCP.icx = tempStartCP.ocx;
        startCP.icy = tempStartCP.ocy;

        var endCP = this.CurrentPoints[this.CurrentPoints.length - 1];
        var tempEndCP = {
          ocx: endCP.ocx,
          ocy: endCP.ocy,
          icx: endCP.icx,
          icy: endCP.icy
        };
        endCP.ocx = tempEndCP.icx;
        endCP.ocy = tempEndCP.icy;
        endCP.icx = tempEndCP.ocx;
        endCP.icy = tempEndCP.ocy;

        this.CurrentPoints[0] = startCP;
        this.CurrentPoints[this.CurrentPoints.length - 1] = endCP;
      }
    },
    initCurveTemplate: function initCurveTemplate() {
      for (var i = 0; i < this.curveTemplateValues.length; i++) {
        this.drawCanvasByData(this.curveTemplateValues[i], this.$refs['curve-template-' + i][0]);
      }
      this.updateCustomCurveTemplate();
    },

    /**
     * @param {Nubmer} page 页码
     */
    updateCustomCurveTemplate: function updateCustomCurveTemplate(page) {
      var that = this;
      this.getCustomCurve({
        type: config.curveType,
        page: page,
        page_size: this.pageSize
      }).then(function (curveDatas) {
        if (curveDatas.list) {
          that.customCurveTemplateValues = curveDatas.list.reverse();
        } else {
          that.customCurveTemplateValues = [];
        }
        that.curveDatas = curveDatas;
        that.currentPage = page || curveDatas.page;
        that.$nextTick(function () {
          for (var j = 0; j < that.customCurveTemplateValues.length; j++) {
            that.drawCanvasByData(that.customCurveTemplateValues[j].data, that.$refs['custom-curve-template-' + j][0]);
          }
        });
      });
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.updateCustomCurveTemplate(page);
    },
    drawCoordinate: function drawCoordinate(canvas, tempConfig) {
      var ctx = canvas.getContext('2d');
      var xWidth = (tempConfig.endX - tempConfig.startX) / 10;
      var yHeight = (tempConfig.startY - tempConfig.endY) / 10;
      var xCoordinate = [];
      var tempX = tempConfig.startX;
      while (tempX > 0) {
        xCoordinate.push(tempX);
        tempX -= xWidth;
      }
      while (tempX < canvas.width) {
        tempX += xWidth;
        if (xCoordinate.indexOf(tempX) < 0) xCoordinate.push(tempX);
      }
      xCoordinate.sort();

      var yCoordinate = [];
      var tempY = tempConfig.startY;
      while (tempY > 0) {
        yCoordinate.push(tempY);
        tempY -= yHeight;
      }
      while (tempY < canvas.height) {
        tempY += yHeight;
        if (yCoordinate.indexOf(tempY) < 0) yCoordinate.push(tempY);
      }
      yCoordinate.sort();

      for (var i = 0; i < xCoordinate.length; i++) {
        ctx.beginPath();
        ctx.moveTo(xCoordinate[i], 0);
        ctx.lineWidth = tempConfig.coordinate.lineWidth;
        ctx.strokeStyle = tempConfig.coordinate.lineColor;
        ctx.lineTo(xCoordinate[i], canvas.height);
        ctx.stroke();
      }

      for (var j = 0; j < yCoordinate.length; j++) {
        ctx.beginPath();
        ctx.moveTo(0, yCoordinate[j]);
        ctx.lineWidth = tempConfig.coordinate.lineWidth;
        ctx.strokeStyle = tempConfig.coordinate.lineColor;
        ctx.lineTo(canvas.width, yCoordinate[j]);
        ctx.stroke();
      }

      ctx.beginPath();
      ctx.moveTo(tempConfig.startX, 0);
      ctx.lineWidth = tempConfig.coordinate.mainLineWidth;
      ctx.strokeStyle = tempConfig.coordinate.mainLineColor;
      ctx.lineTo(tempConfig.startX, canvas.height);
      ctx.stroke();

      ctx.beginPath();
      ctx.moveTo(0, tempConfig.startY);
      ctx.lineWidth = tempConfig.coordinate.mainLineWidth;
      ctx.strokeStyle = tempConfig.coordinate.mainLineColor;
      ctx.lineTo(canvas.width, tempConfig.startY);
      ctx.stroke();

      ctx.beginPath();
      ctx.moveTo(tempConfig.endX, 0);
      ctx.lineWidth = tempConfig.coordinate.mainLineWidth;
      ctx.strokeStyle = tempConfig.coordinate.mainLineColor;
      ctx.lineTo(tempConfig.endX, canvas.height);
      ctx.stroke();

      ctx.beginPath();
      ctx.moveTo(0, tempConfig.endY);
      ctx.lineWidth = tempConfig.coordinate.mainLineWidth;
      ctx.strokeStyle = tempConfig.coordinate.mainLineColor;
      ctx.lineTo(canvas.width, tempConfig.endY);
      ctx.stroke();

      // ctx.beginPath()
      ctx.font = tempConfig.coordinate.fontStyle;
      ctx.fillStyle = tempConfig.coordinate.fontColor;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('(0,0)', tempConfig.startX - 30, tempConfig.startY + 15);
      ctx.fillText('(1,1)', tempConfig.endX + 25, tempConfig.endY - 15);
      // ctx.stroke()
    },
    drawValueCanvas: function drawValueCanvas() {
      var canvas = this.$refs['value-canvas'];
      if (!canvas) return;
      this.drawCanvasByData(this.value, canvas);
    },
    drawCanvasByData: function drawCanvasByData(data, canvas) {
      if (data.length === 0) return;
      if (canvas.getContext == null) return;
      var tempPoints = [];
      var ctx = canvas.getContext('2d');
      var startX = canvas.width / 5;
      var endX = canvas.width * 4 / 5;
      var startY = canvas.height * 8 / 10;
      var endY = canvas.height * 2 / 10;
      var canvasWidth = canvas.width;
      var canvasHeight = canvas.height;
      var tempConfig = {
        ctx: ctx,
        startX: startX,
        endX: endX,
        startY: startY,
        endY: endY,
        tLen: endX - startX,
        handlePointLen: 5
      };
      for (var i = 0; i < data.length; i++) {
        var iTLen = void 0,
            oTLen = void 0;
        if (i === 0) {
          iTLen = (tempConfig.endX - tempConfig.startX) * (data[1][0] - data[0][0]);
          oTLen = (tempConfig.endX - tempConfig.startX) * (data[1][0] - data[0][0]);
        } else if (i === data.length - 1) {
          iTLen = (tempConfig.endX - tempConfig.startX) * (data[i][0] - data[i - 1][0]);
          oTLen = (tempConfig.endX - tempConfig.startX) * (data[i][0] - data[i - 1][0]);
        } else {
          iTLen = (tempConfig.endX - tempConfig.startX) * (data[i][0] - data[i - 1][0]);
          oTLen = (tempConfig.endX - tempConfig.startX) * (data[i + 1][0] - data[i][0]);
        }
        var point = this.getCurvePoint(data[i], iTLen, oTLen, tempConfig);
        tempPoints.push(point);
      }
      if (!(tempPoints[0].ocx - tempPoints[0].x > 0 && tempPoints[tempPoints.length - 1].icx - tempPoints[tempPoints.length - 1].x < 0)) {
        var startCP = tempPoints[0];
        var tempStartCP = {
          ocx: startCP.ocx,
          ocy: startCP.ocy,
          icx: startCP.icx,
          icy: startCP.icy
        };
        startCP.ocx = tempStartCP.icx;
        startCP.ocy = tempStartCP.icy;
        startCP.icx = tempStartCP.ocx;
        startCP.icy = tempStartCP.ocy;

        var endCP = tempPoints[tempPoints.length - 1];
        var tempEndCP = {
          ocx: endCP.ocx,
          ocy: endCP.ocy,
          icx: endCP.icx,
          icy: endCP.icy
        };
        endCP.ocx = tempEndCP.icx;
        endCP.ocy = tempEndCP.icy;
        endCP.icx = tempEndCP.ocx;
        endCP.icy = tempEndCP.ocy;

        tempPoints[0] = startCP;
        tempPoints[tempPoints.length - 1] = endCP;
      }

      ctx.clearRect(0, 0, canvasWidth, canvasHeight);
      for (var _i = 0; _i < tempPoints.length; _i++) {
        var pointItem = tempPoints[_i];

        // 绘制节点
        // ctx.lineWidth = config.round.point.width
        // ctx.strokeStyle = config.round.point.color
        // ctx.fillStyle = config.round.point.fill
        // ctx.beginPath()
        // ctx.arc(pointItem.x, pointItem.y, config.round.point.radius, 0, 2 * Math.PI, true)
        // ctx.stroke()

        if (_i <= tempPoints.length - 2) {
          var nextPointItem = tempPoints[_i + 1];
          ctx.beginPath();
          ctx.moveTo(pointItem.x, pointItem.y);
          ctx.lineWidth = config.round.curve.width;
          ctx.strokeStyle = config.round.curve.color;
          ctx.bezierCurveTo(pointItem.ocx, pointItem.ocy, nextPointItem.icx, nextPointItem.icy, nextPointItem.x, nextPointItem.y);
          ctx.stroke();
        }
      }
    },
    setValueByTemplate: function setValueByTemplate(data) {
      this.value = data;
      this.initCurve();
    },
    setUpCanvas: function setUpCanvas(canvasWidth, canvasHeight) {
      config.startX = Math.floor(canvasWidth * 3 / 10);
      config.endX = Math.floor(canvasWidth * 7 / 10);
      config.startY = Math.floor(canvasHeight * 9 / 10);
      config.endY = Math.floor(Number(canvasHeight) / 10);
    },
    getCurvePoint: function getCurvePoint(keyframeNode, iTLen, oTLen, tempConfig) {
      var currentConfig = tempConfig || config;
      var totalX = currentConfig.endX - currentConfig.startX;
      var totalY = currentConfig.startY - currentConfig.endY;

      var ocx = keyframeNode[0] * totalX + oTLen / 3 + currentConfig.startX;
      var icx = keyframeNode[0] * totalX - iTLen / 3 + currentConfig.startX;

      var ocy = -1 * keyframeNode[1] * totalY - oTLen * keyframeNode[3] / 3 + currentConfig.startY;
      var icy = -1 * keyframeNode[1] * totalY + iTLen * keyframeNode[2] / 3 + currentConfig.startY;

      var point = {
        keyframeType: KeyframeType.FREE_SMOOTH,
        x: keyframeNode[0] * totalX + currentConfig.startX,
        y: -1 * keyframeNode[1] * totalY + currentConfig.startY,
        inTangent: keyframeNode[2],
        outTangent: keyframeNode[3],
        icx: icx, // 控制点的X坐标，我们把控制点的x(t)坐标设置为总长度的三分之一
        icy: icy,
        ocx: ocx,
        ocy: ocy, // 控制点的Y坐标，由于 h/(tLen/3) = outTangent  =>  h = outTangent * (tLen/3)
        hix: 0,
        hiy: 0,
        hox: 0,
        hoy: 0,
        dix: 0,
        diy: 0,
        dox: 0,
        doy: 0
      };

      var iCLen = Math.pow(Math.pow(point.x - icx, 2) + Math.pow(icy - point.y, 2), 1 / 2);
      var hIcRate = currentConfig.handlePointLen / iCLen;
      point.hix = point.x - hIcRate * iTLen / 3;
      point.hiy = point.y + hIcRate * (point.icy - point.y);
      point.dix = point.hix;
      point.diy = point.hiy;

      var oCLen = Math.pow(Math.pow(point.x - ocx, 2) + Math.pow(ocy - point.y, 2), 1 / 2);
      var hOcRate = currentConfig.handlePointLen / oCLen;
      point.hox = point.x + hOcRate * oTLen / 3;
      point.hoy = point.y - hOcRate * (point.y - point.ocy);
      point.dox = point.hox;
      point.doy = point.hoy;
      return point;
    },
    updateCurvePointByNode: function updateCurvePointByNode(clickPoint, deltaX, deltaY) {
      this.CurrentPoints[clickPoint].icx += deltaX;
      this.CurrentPoints[clickPoint].icy += deltaY;
      this.CurrentPoints[clickPoint].ocx += deltaX;
      this.CurrentPoints[clickPoint].ocy += deltaY;
      this.CurrentPoints[clickPoint].hix += deltaX;
      this.CurrentPoints[clickPoint].hiy += deltaY;
      this.CurrentPoints[clickPoint].hox += deltaX;
      this.CurrentPoints[clickPoint].hoy += deltaY;
      this.CurrentPoints[clickPoint].dix += deltaX;
      this.CurrentPoints[clickPoint].diy += deltaY;
      this.CurrentPoints[clickPoint].dox += deltaX;
      this.CurrentPoints[clickPoint].doy += deltaY;

      // if (Number.parseInt(clickPoint) === 0 || Number.parseInt(clickPoint) === (this.CurrentPoints.length - 1)) {
      //   config.startX = this.CurrentPoints[0].x
      //   config.endX = this.CurrentPoints[this.CurrentPoints.length - 1].x
      //   config.startY = this.CurrentPoints[0].y
      //   config.endY = this.CurrentPoints[this.CurrentPoints.length - 1].y
      // }
    },
    updateCurveNodeByCountrolPoint: function updateCurveNodeByCountrolPoint(nodeIndex, clickPointType) {
      var controlPoint = this.CurrentPoints[this.clickPoint];
      if (clickPointType === 2) {
        // in
        var mLen = Math.pow(Math.pow(controlPoint.hiy - controlPoint.y, 2) + Math.pow(controlPoint.x - controlPoint.hix, 2), 1 / 2);
        var inTangent = (controlPoint.hiy - controlPoint.y) / (controlPoint.x - controlPoint.hix);
        this.CurrentPoints[this.clickPoint].inTangent = inTangent;
        this.CurrentPoints[this.clickPoint].dix = controlPoint.x + config.handlePointLen * (controlPoint.hix - controlPoint.x) / mLen;
        this.CurrentPoints[this.clickPoint].diy = controlPoint.y + config.handlePointLen * (controlPoint.hiy - controlPoint.y) / mLen;
        this.CurrentPoints[this.clickPoint].icy = controlPoint.y + inTangent * (controlPoint.x - controlPoint.icx);

        if (this.CurrentPoints[this.clickPoint].keyframeType === KeyframeType.FREE_SMOOTH) {
          this.CurrentPoints[this.clickPoint].dox = controlPoint.x + (controlPoint.x - this.CurrentPoints[this.clickPoint].dix);
          this.CurrentPoints[this.clickPoint].doy = controlPoint.y + (controlPoint.y - this.CurrentPoints[this.clickPoint].diy);
          this.CurrentPoints[this.clickPoint].hox = controlPoint.x + (controlPoint.x - this.CurrentPoints[this.clickPoint].hix);
          this.CurrentPoints[this.clickPoint].hoy = controlPoint.y + (controlPoint.y - this.CurrentPoints[this.clickPoint].hiy);
          this.CurrentPoints[this.clickPoint].ocx = controlPoint.x + (controlPoint.x - this.CurrentPoints[this.clickPoint].icx);
          this.CurrentPoints[this.clickPoint].ocy = controlPoint.y + (controlPoint.y - this.CurrentPoints[this.clickPoint].icy);
          this.CurrentPoints[this.clickPoint].outTangent = inTangent;
        }
      } else if (clickPointType === 3) {
        // out
        var _mLen = Math.pow(Math.pow(controlPoint.hoy - controlPoint.y, 2) + Math.pow(controlPoint.x - controlPoint.hox, 2), 1 / 2);
        var outTangent = (controlPoint.hoy - controlPoint.y) / (controlPoint.x - controlPoint.hox);
        this.CurrentPoints[this.clickPoint].outTangent = outTangent;
        this.CurrentPoints[this.clickPoint].dox = controlPoint.x + config.handlePointLen * (controlPoint.hox - controlPoint.x) / _mLen;
        this.CurrentPoints[this.clickPoint].doy = controlPoint.y + config.handlePointLen * (controlPoint.hoy - controlPoint.y) / _mLen;
        this.CurrentPoints[this.clickPoint].ocy = controlPoint.y + outTangent * (controlPoint.x - controlPoint.ocx);

        if (this.CurrentPoints[this.clickPoint].keyframeType === KeyframeType.FREE_SMOOTH) {
          this.CurrentPoints[this.clickPoint].dix = controlPoint.x + (controlPoint.x - this.CurrentPoints[this.clickPoint].dox);
          this.CurrentPoints[this.clickPoint].diy = controlPoint.y + (controlPoint.y - this.CurrentPoints[this.clickPoint].doy);
          this.CurrentPoints[this.clickPoint].hix = controlPoint.x + (controlPoint.x - this.CurrentPoints[this.clickPoint].hox);
          this.CurrentPoints[this.clickPoint].hiy = controlPoint.y + (controlPoint.y - this.CurrentPoints[this.clickPoint].hoy);
          this.CurrentPoints[this.clickPoint].icx = controlPoint.x + (controlPoint.x - this.CurrentPoints[this.clickPoint].ocx);
          this.CurrentPoints[this.clickPoint].icy = controlPoint.y + (controlPoint.y - this.CurrentPoints[this.clickPoint].ocy);
          this.CurrentPoints[this.clickPoint].inTangent = outTangent;
        }
      }
    },
    outPutData: function outPutData() {
      var data = [];
      var totalX = config.endX - config.startX; // this.CurrentPoints[this.CurrentPoints.length - 1].x - this.CurrentPoints[0].x
      var totalY = config.startY - config.endY; // this.CurrentPoints[0].y - this.CurrentPoints[this.CurrentPoints.length - 1].y
      for (var i = 0; i < this.CurrentPoints.length; i++) {
        var point = this.CurrentPoints[i];
        var x = (point.x - config.startX) / totalX;
        var y = (config.startY - point.y) / totalY;
        var inTangent = (point.icy - point.y) / (point.x - point.icx);
        var outTangent = (point.y - point.ocy) / (point.ocx - point.x);
        var item = [x, y, inTangent, outTangent];
        data.push(item);
      }
      this.$emit('change', {
        keyframes: data
      });

      return data;
    },
    drawCurve: function drawCurve() {
      this.ctx.clearRect(0, 0, this.mainCurveWidth, this.mainCurveHeight);
      this.drawCoordinate(this.mainCurveCanvas, config);
      for (var i = 0; i < this.CurrentPoints.length; i++) {
        var pointItem = this.CurrentPoints[i];
        if (config.drawControlPoint) {
          // 绘制入角控制点
          this.ctx.beginPath();
          this.ctx.moveTo(pointItem.icx, pointItem.icy);
          this.ctx.lineWidth = config.round.point.width;
          this.ctx.strokeStyle = config.round.point.controlPointColor;
          this.ctx.fillStyle = config.round.point.fill;
          this.ctx.beginPath();
          this.ctx.arc(pointItem.icx, pointItem.icy, config.round.point.radius, 0, 2 * Math.PI, true);
          this.ctx.fill();
          this.ctx.stroke();

          // 控制点连线到曲线点
          this.ctx.beginPath();
          this.ctx.moveTo(pointItem.icx, pointItem.icy);
          this.ctx.lineWidth = config.round.cpline.width;
          this.ctx.strokeStyle = config.round.cpline.color;
          this.ctx.lineTo(pointItem.x, pointItem.y);
          this.ctx.stroke();

          // 绘制出角控制点
          this.ctx.beginPath();
          this.ctx.moveTo(pointItem.ocx, pointItem.ocy);
          this.ctx.lineWidth = config.round.point.width;
          this.ctx.strokeStyle = config.round.point.controlPointColor;
          this.ctx.fillStyle = config.round.point.fill;
          this.ctx.beginPath();
          this.ctx.arc(pointItem.ocx, pointItem.ocy, config.round.point.radius, 0, 2 * Math.PI, true);
          this.ctx.fill();
          this.ctx.stroke();

          // 控制点连线到曲线点
          this.ctx.beginPath();
          this.ctx.moveTo(pointItem.ocx, pointItem.ocy);
          this.ctx.lineWidth = config.round.cpline.width;
          this.ctx.strokeStyle = config.round.cpline.color;
          this.ctx.lineTo(pointItem.x, pointItem.y);
          this.ctx.stroke();
        }

        if (config.drawHandlePoint && _Number$parseInt(this.selectedPoint, 10) === i) {
          // 绘制入角切线点
          this.ctx.beginPath();
          this.ctx.moveTo(pointItem.hix, pointItem.hiy);
          this.ctx.lineWidth = config.round.point.width;
          this.ctx.strokeStyle = config.round.point.handleColor;
          this.ctx.fillStyle = config.round.point.fill;
          this.ctx.beginPath();
          this.ctx.arc(pointItem.hix, pointItem.hiy, config.round.point.handleRadius, 0, 2 * Math.PI, true);
          this.ctx.fill();
          this.ctx.stroke();

          // 控制点连线到如角切线点
          this.ctx.beginPath();
          this.ctx.moveTo(pointItem.hix, pointItem.hiy);
          this.ctx.lineWidth = config.round.handleline.width;
          this.ctx.strokeStyle = config.round.handleline.color;
          this.ctx.lineTo(pointItem.x, pointItem.y);
          this.ctx.stroke();

          // 绘制出角切线点
          this.ctx.beginPath();
          this.ctx.moveTo(pointItem.hox, pointItem.hoy);
          this.ctx.lineWidth = config.round.point.width;
          this.ctx.strokeStyle = config.round.point.handleColor;
          this.ctx.fillStyle = config.round.point.fill;
          this.ctx.beginPath();
          this.ctx.arc(pointItem.hox, pointItem.hoy, config.round.point.handleRadius, 0, 2 * Math.PI, true);
          this.ctx.fill();
          this.ctx.stroke();

          // 控制点连线到出角切线点
          this.ctx.beginPath();
          this.ctx.moveTo(pointItem.hox, pointItem.hoy);
          this.ctx.lineWidth = config.round.handleline.width;
          this.ctx.strokeStyle = config.round.handleline.color;
          this.ctx.lineTo(pointItem.x, pointItem.y);
          this.ctx.stroke();
        }

        if (config.drawDirectPoint && _Number$parseInt(this.selectedPoint, 10) === i) {
          // 绘制入角直径点
          this.ctx.beginPath();
          this.ctx.moveTo(pointItem.dix, pointItem.diy);
          this.ctx.lineWidth = config.round.point.width;
          this.ctx.strokeStyle = config.round.point.drawHandleColor;
          this.ctx.fillStyle = config.round.point.fill;
          this.ctx.beginPath();
          this.ctx.arc(pointItem.dix, pointItem.diy, config.round.point.handleRadius, 0, 2 * Math.PI, true);
          this.ctx.fill();
          this.ctx.stroke();

          // 控制点连线到入角直径点
          this.ctx.beginPath();
          this.ctx.moveTo(pointItem.dix, pointItem.diy);
          this.ctx.lineWidth = config.round.handleline.width;
          this.ctx.strokeStyle = config.round.handleline.color;
          this.ctx.lineTo(pointItem.x, pointItem.y);
          this.ctx.stroke();

          // 绘制入角直径点
          this.ctx.beginPath();
          this.ctx.moveTo(pointItem.dox, pointItem.doy);
          this.ctx.lineWidth = config.round.point.width;
          this.ctx.strokeStyle = config.round.point.drawHandleColor;
          this.ctx.fillStyle = config.round.point.fill;
          this.ctx.beginPath();
          this.ctx.arc(pointItem.dox, pointItem.doy, config.round.point.handleRadius, 0, 2 * Math.PI, true);
          this.ctx.fill();
          this.ctx.stroke();

          // 控制点连线到出角直径点
          this.ctx.beginPath();
          this.ctx.moveTo(pointItem.dox, pointItem.doy);
          this.ctx.lineWidth = config.round.handleline.width;
          this.ctx.strokeStyle = config.round.handleline.color;
          this.ctx.lineTo(pointItem.x, pointItem.y);
          this.ctx.stroke();
        }

        // 绘制节点
        this.ctx.lineWidth = config.round.point.width;
        this.ctx.strokeStyle = config.round.point.color;
        this.ctx.fillStyle = config.round.point.fill;
        this.ctx.beginPath();
        this.ctx.arc(pointItem.x, pointItem.y, config.round.point.radius, 0, 2 * Math.PI, true);
        if (_Number$parseInt(this.selectedPoint, 10) === i && this.clickPointType === 1) {
          this.ctx.fillStyle = config.round.point.selectedColor;
          this.ctx.fill();
        }
        this.ctx.stroke();

        if (i <= this.CurrentPoints.length - 2) {
          var nextPointItem = this.CurrentPoints[i + 1];
          this.ctx.beginPath();
          this.ctx.moveTo(pointItem.x, pointItem.y);
          this.ctx.lineWidth = config.round.curve.width;
          this.ctx.strokeStyle = config.round.curve.color;
          this.ctx.bezierCurveTo(pointItem.ocx, pointItem.ocy, nextPointItem.icx, nextPointItem.icy, nextPointItem.x, nextPointItem.y);
          this.ctx.stroke();
        }
      }
    },
    mouseDownFun: function mouseDownFun(e) {
      e = this.getPoint(e);
      var dx = void 0,
          dy = void 0;
      for (var v in this.CurrentPoints) {
        dx = this.CurrentPoints[v].x - e.x;
        dy = this.CurrentPoints[v].y - e.y;
        // 判断点击区域是否在可见圆内
        if (Math.pow(dx, 2) + Math.pow(dy, 2) < Math.pow(config.round.point.radius, 2)) {
          this.clickPoint = v;
          this.selectedPoint = v;
          this.sourcePoint = e;
          this.clickPointType = 1; // curve point
          this.mainCurveCanvas.style.cursor = 'move';
          return;
        }

        dx = this.CurrentPoints[v].hix - e.x;
        dy = this.CurrentPoints[v].hiy - e.y;
        // 判断点击区域是否在可见圆内
        if (Math.pow(dx, 2) + Math.pow(dy, 2) < Math.pow(config.round.point.handleRadius, 2)) {
          this.clickPoint = v;
          this.selectedPoint = v;
          this.sourcePoint = e;
          this.clickPointType = 2; // in control point
          this.mainCurveCanvas.style.cursor = 'move';
          return;
        }

        dx = this.CurrentPoints[v].hox - e.x;
        dy = this.CurrentPoints[v].hoy - e.y;
        // 判断点击区域是否在可见圆内
        if (Math.pow(dx, 2) + Math.pow(dy, 2) < Math.pow(config.round.point.handleRadius, 2)) {
          this.clickPoint = v;
          this.selectedPoint = v;
          this.sourcePoint = e;
          this.clickPointType = 3; // out control point
          this.mainCurveCanvas.style.cursor = 'move';
          return;
        }
      }

      if (this.isOnLine(e) && config.allowMoveLine) {
        this.clickPoint = 1;
        this.selectedPoint = 1;
        this.sourcePoint = e;
        this.clickPointType = 4; // online
        this.mainCurveCanvas.style.cursor = 'move';
        return;
      }

      this.clickPointType = -1;
      this.selectedPoint = -1;
    },
    mouseMoveFun: function mouseMoveFun(e) {
      if (this.clickPoint) {
        e = this.getPoint(e);
        if (this.clickPointType === 1) {
          var deltaX = e.x - this.sourcePoint.x;
          var deltaY = e.y - this.sourcePoint.y;
          this.CurrentPoints[this.clickPoint].x += deltaX;
          this.CurrentPoints[this.clickPoint].y += deltaY;
          // 这里可以添加约束
          if (!(this.CurrentPoints[0].ocx - this.CurrentPoints[0].x > 0 && this.CurrentPoints[this.CurrentPoints.length - 1].icx - this.CurrentPoints[this.CurrentPoints.length - 1].x < 0)) {
            //
            this.CurrentPoints[this.clickPoint].x -= e.x - this.sourcePoint.x;
            this.CurrentPoints[this.clickPoint].y -= e.y - this.sourcePoint.y;
          } else {
            this.updateCurvePointByNode(this.clickPoint, deltaX, deltaY);
          }
        } else if (this.clickPointType === 2) {
          this.CurrentPoints[this.clickPoint].hix += e.x - this.sourcePoint.x;
          this.CurrentPoints[this.clickPoint].hiy += e.y - this.sourcePoint.y;
          // 这里可以添加约束
          if (!(this.CurrentPoints[0].ocx - this.CurrentPoints[0].x > 0 && this.CurrentPoints[this.CurrentPoints.length - 1].icx - this.CurrentPoints[this.CurrentPoints.length - 1].x < 0)) {
            //
            this.CurrentPoints[this.clickPoint].hix -= e.x - this.sourcePoint.x;
            this.CurrentPoints[this.clickPoint].hiy -= e.y - this.sourcePoint.y;
          }
          this.updateCurveNodeByCountrolPoint(this.clickPoint, this.clickPointType);
        } else if (this.clickPointType === 3) {
          this.CurrentPoints[this.clickPoint].hox += e.x - this.sourcePoint.x;
          this.CurrentPoints[this.clickPoint].hoy += e.y - this.sourcePoint.y;
          // 这里可以添加约束
          if (!(this.CurrentPoints[0].ocx - this.CurrentPoints[0].x > 0 && this.CurrentPoints[this.CurrentPoints.length - 1].icx - this.CurrentPoints[this.CurrentPoints.length - 1].x < 0)) {
            //
            this.CurrentPoints[this.clickPoint].hox -= e.x - this.sourcePoint.x;
            this.CurrentPoints[this.clickPoint].hoy -= e.y - this.sourcePoint.y;
          }
          this.updateCurveNodeByCountrolPoint(this.clickPoint, this.clickPointType);
        } else if (this.clickPointType === 4) {
          var _deltaX = e.x - this.sourcePoint.x;
          var _deltaY = e.y - this.sourcePoint.y;
          for (var i = 0; i < this.CurrentPoints.length; i++) {
            this.CurrentPoints[i].x += _deltaX;
            this.CurrentPoints[i].y += _deltaY;
            this.CurrentPoints[i].icx += _deltaX;
            this.CurrentPoints[i].icy += _deltaY;
            this.CurrentPoints[i].ocx += _deltaX;
            this.CurrentPoints[i].ocy += _deltaY;
            this.CurrentPoints[i].hix += _deltaX;
            this.CurrentPoints[i].hiy += _deltaY;
            this.CurrentPoints[i].hox += _deltaX;
            this.CurrentPoints[i].hoy += _deltaY;
            this.CurrentPoints[i].dix += _deltaX;
            this.CurrentPoints[i].diy += _deltaY;
            this.CurrentPoints[i].dox += _deltaX;
            this.CurrentPoints[i].doy += _deltaY;
          }
        }
        this.sourcePoint = e;
        this.drawCurve();
      } else {
        e = this.getPoint(e);

        var dx = void 0,
            dy = void 0;
        var isOnPoint = false;
        for (var v in this.CurrentPoints) {
          dx = this.CurrentPoints[v].x - e.x;
          dy = this.CurrentPoints[v].y - e.y;
          // 判断点击区域是否在可见圆内
          if (Math.pow(dx, 2) + Math.pow(dy, 2) < Math.pow(config.round.point.radius, 2)) {
            isOnPoint = true;
          }

          dx = this.CurrentPoints[v].hix - e.x;
          dy = this.CurrentPoints[v].hiy - e.y;
          // 判断点击区域是否在可见圆内
          if (Math.pow(dx, 2) + Math.pow(dy, 2) < Math.pow(config.round.point.radius, 2)) {
            isOnPoint = true;
          }

          dx = this.CurrentPoints[v].hox - e.x;
          dy = this.CurrentPoints[v].hoy - e.y;
          // 判断点击区域是否在可见圆内
          if (Math.pow(dx, 2) + Math.pow(dy, 2) < Math.pow(config.round.point.radius, 2)) {
            isOnPoint = true;
          }
        }
        if (this.mainCurveCanvas && this.mainCurveCanvas.style) {
          this.mainCurveCanvas.style.cursor = isOnPoint ? 'pointer' : 'default';
        }

        if (this.isOnLine(e) && config.allowMoveLine) {
          if (this.mainCurveCanvas && this.mainCurveCanvas.style) {
            this.mainCurveCanvas.style.cursor = 'grab';
          }
        } else {
          if (this.mainCurveCanvas && this.mainCurveCanvas.style) {
            this.mainCurveCanvas.style.cursor = isOnPoint ? 'pointer' : 'default';
          }
          // this.mainCurveCanvas.style.cursor = 'default'
        }
        // this.mainCurveCanvas.style.cursor = isOnPoint ? 'pointer' : 'default'
      }
    },
    mouseUpFun: function mouseUpFun(e) {
      this.clickPoint = null;
      this.mainCurveCanvas.style.cursor = 'default';
      for (var i = 0; i < this.CurrentPoints.length; i++) {
        var pointItem = this.CurrentPoints[i];
        pointItem.hix = pointItem.dix;
        pointItem.hox = pointItem.dox;
        pointItem.hiy = pointItem.diy;
        pointItem.hoy = pointItem.doy;
      }
      this.drawCurve();
      this.getBezierSet();
      this.value = this.outPutData();
    },
    mousedblclickFun: function mousedblclickFun(e) {
      e = this.getPoint(e);
      var linePoint = this.isOnLine(e);
      if (linePoint) {
        this.addNewKeyframe(this.onLineSet, linePoint);
        this.selectedPoint = this.onLineSet + 1;
        this.clickPointType = 1;
        this.drawCurve();
      }
    },
    setKeyframeFlat: function setKeyframeFlat(selectedPoint) {
      selectedPoint = _Number$parseInt(selectedPoint, 10);
      this.value[selectedPoint][2] = 0;
      this.value[selectedPoint][3] = 0;
      this.CurrentPoints[selectedPoint].inTangent = 0;
      this.CurrentPoints[selectedPoint].outTangent = 0;
      if (selectedPoint > 0) {
        this.CurrentPoints[selectedPoint].icy = this.CurrentPoints[selectedPoint].y;
        this.CurrentPoints[selectedPoint].icx = this.CurrentPoints[selectedPoint].x - (this.CurrentPoints[selectedPoint].x - this.CurrentPoints[selectedPoint - 1].x) / 3;
      }
      if (selectedPoint < this.CurrentPoints.length - 1) {
        this.CurrentPoints[selectedPoint].ocy = this.CurrentPoints[selectedPoint].y;
        this.CurrentPoints[selectedPoint].ocx = this.CurrentPoints[selectedPoint].x + (this.CurrentPoints[selectedPoint + 1].x - this.CurrentPoints[selectedPoint].x) / 3;
      }
      this.CurrentPoints[selectedPoint].hiy = this.CurrentPoints[selectedPoint].y;
      this.CurrentPoints[selectedPoint].hix = this.CurrentPoints[selectedPoint].x - config.handlePointLen;
      this.CurrentPoints[selectedPoint].hoy = this.CurrentPoints[selectedPoint].y;
      this.CurrentPoints[selectedPoint].hox = this.CurrentPoints[selectedPoint].x + config.handlePointLen;
      this.CurrentPoints[selectedPoint].diy = this.CurrentPoints[selectedPoint].y;
      this.CurrentPoints[selectedPoint].dix = this.CurrentPoints[selectedPoint].x - config.handlePointLen;
      this.CurrentPoints[selectedPoint].doy = this.CurrentPoints[selectedPoint].y;
      this.CurrentPoints[selectedPoint].dox = this.CurrentPoints[selectedPoint].x + config.handlePointLen;
      this.drawCurve();
    },
    updateNeighborNode: function updateNeighborNode(lineIndex, iTLen, oTLen) {
      if (iTLen) {
        // update outTangent
        var outTangent = (this.CurrentPoints[lineIndex].y - this.CurrentPoints[lineIndex].ocy) / (this.CurrentPoints[lineIndex].ocx - this.CurrentPoints[lineIndex].x);
        this.CurrentPoints[lineIndex].ocx = this.CurrentPoints[lineIndex].x + iTLen / 3;
        this.CurrentPoints[lineIndex].ocy = this.CurrentPoints[lineIndex].y - outTangent * iTLen / 3;

        var oCLen = Math.pow(Math.pow(this.CurrentPoints[lineIndex].x - this.CurrentPoints[lineIndex].ocx, 2) + Math.pow(this.CurrentPoints[lineIndex].ocy - this.CurrentPoints[lineIndex].y, 2), 1 / 2);
        var hOcRate = config.handlePointLen / oCLen;
        this.CurrentPoints[lineIndex].hox = this.CurrentPoints[lineIndex].x + hOcRate * iTLen / 3;
        this.CurrentPoints[lineIndex].hoy = this.CurrentPoints[lineIndex].y - hOcRate * (this.CurrentPoints[lineIndex].y - this.CurrentPoints[lineIndex].ocy);
        this.CurrentPoints[lineIndex].dox = this.CurrentPoints[lineIndex].hox;
        this.CurrentPoints[lineIndex].doy = this.CurrentPoints[lineIndex].hoy;
      }

      if (oTLen) {
        // update inTangent
        var inTangent = (this.CurrentPoints[lineIndex + 1].icy - this.CurrentPoints[lineIndex + 1].y) / (this.CurrentPoints[lineIndex + 1].x - this.CurrentPoints[lineIndex + 1].icx);
        this.CurrentPoints[lineIndex + 1].icx = this.CurrentPoints[lineIndex + 1].x - oTLen / 3;
        this.CurrentPoints[lineIndex + 1].icy = this.CurrentPoints[lineIndex + 1].y + inTangent * oTLen / 3;

        var iCLen = Math.pow(Math.pow(this.CurrentPoints[lineIndex + 1].x - this.CurrentPoints[lineIndex + 1].icx, 2) + Math.pow(this.CurrentPoints[lineIndex + 1].icy - this.CurrentPoints[lineIndex + 1].y, 2), 1 / 2);
        var hIcRate = config.handlePointLen / iCLen;
        this.CurrentPoints[lineIndex + 1].hix = this.CurrentPoints[lineIndex + 1].x - hIcRate * oTLen / 3;
        this.CurrentPoints[lineIndex + 1].hiy = this.CurrentPoints[lineIndex + 1].y + hIcRate * (this.CurrentPoints[lineIndex + 1].icy - this.CurrentPoints[lineIndex + 1].y);
        this.CurrentPoints[lineIndex + 1].dix = this.CurrentPoints[lineIndex + 1].hix;
        this.CurrentPoints[lineIndex + 1].diy = this.CurrentPoints[lineIndex + 1].hiy;
      }
    },
    removeKeyframe: function removeKeyframe(e) {
      if (this.CurrentPoints.length <= 2) return;
      var lineIndex = _Number$parseInt(this.selectedPoint, 10);
      this.value.splice(lineIndex, 1);
      var removePoint = this.CurrentPoints.splice(lineIndex, 1);
      if (lineIndex > 0) {
        var oTLen = this.CurrentPoints[lineIndex].x - removePoint.x;
        this.updateNeighborNode(lineIndex, null, oTLen);
      }
      if (lineIndex < this.CurrentPoints.length - 2) {
        var iTLen = this.CurrentPoints[lineIndex].x - this.CurrentPoints[lineIndex - 1].x;
        this.updateNeighborNode(lineIndex, iTLen, null);
      }
      this.selectedPoint = -1;
      this.clickPointType = -1;
      this.drawCurve();
      this.$emit('removeKeyframe', {
        keyIndex: lineIndex,
        keyframes: this.value,
        valueTransformer: this.valueTransformer
      });
    },
    addNewKeyframe: function addNewKeyframe(lineIndex, point) {
      var tLen = this.CurrentPoints[lineIndex + 1].x - this.CurrentPoints[lineIndex].x;
      var t = (point.x - this.CurrentPoints[lineIndex].x) / (this.CurrentPoints[lineIndex + 1].x - this.CurrentPoints[lineIndex].x);
      var p1 = this.CurrentPoints[lineIndex];
      var p2 = this.CurrentPoints[lineIndex + 1];
      var cp1 = {
        x: this.CurrentPoints[lineIndex].ocx,
        y: this.CurrentPoints[lineIndex].ocy
      };
      var cp2 = {
        x: this.CurrentPoints[lineIndex + 1].icx,
        y: this.CurrentPoints[lineIndex + 1].icy
      };
      var derivative = this.getDerivative(t, p1, cp1, cp2, p2);
      var tangent = -1 * derivative / tLen;

      var totalT = this.value[lineIndex][0] + (this.value[lineIndex + 1][0] - this.value[lineIndex][0]) * t;
      // let totalY = (this.CurrentPoints[0].y - point.y) / (this.CurrentPoints[0].y - this.CurrentPoints[this.CurrentPoints.length - 1].y)
      var totalY = (config.startY - point.y) / (config.startY - config.endY);
      var keyframeNode = [totalT, totalY, tangent, tangent];

      var iTLen = point.x - this.CurrentPoints[lineIndex].x;
      var oTLen = this.CurrentPoints[lineIndex + 1].x - point.x;
      var newPoint = this.getCurvePoint(keyframeNode, iTLen, oTLen);
      this.updateNeighborNode(lineIndex, iTLen, oTLen);
      this.CurrentPoints.splice(lineIndex + 1, 0, newPoint);
      this.value.splice(lineIndex + 1, 0, keyframeNode);
      this.$emit('addKeyframe', {
        keyIndex: lineIndex,
        keyframes: this.value,
        newKeyframe: keyframeNode,
        valueTransformer: this.valueTransformer
      });
      // alert(derivative/tLen)
    },

    /**
     * @desc 三阶贝塞尔求度
     * @param {number} t 当前百分比
     * @param {Array} p1 起点坐标
     * @param {Array} p2 终点坐标
     * @param {Array} cp1 控制点1
     * @param {Array} cp2 控制点2
     */
    getDerivative: function getDerivative(t, p1, cp1, cp2, p2) {
      var t1 = 1 - t;
      var v = -3 * p1.y * t1 * t1 + 3 * cp1.y * t1 * (1 - 3 * t) + 3 * cp2.y * t * (2 - 3 * t) + 3 * p2.y * Math.pow(t, 2);
      if (v === Infinity || isNaN(v)) return 0;
      return v;
    },
    getPoint: function getPoint(e) {
      e = e || window.event;
      var offset = this.mainCurveCanvas ? this.mainCurveCanvas.getBoundingClientRect() : { x: 0, top: 0 };
      return {
        x: e.pageX - Math.floor(offset.x),
        y: e.pageY - Math.floor(offset.top)
      };
    },
    isOnLine: function isOnLine(currentPoint) {
      for (var i = 0; i < this.lineSet.length; i++) {
        var set = this.lineSet[i];
        // eslint-disable-next-line no-continue
        if (!set[currentPoint.x]) continue;
        var mapY = set[currentPoint.x].y;

        if (Math.abs(currentPoint.y - mapY) < 10) {
          this.onLineSet = i;
          return set[currentPoint.x];
        }
      }
      return false;
    },
    getBezierSet: function getBezierSet() {
      var that = this;
      var sets = [];
      for (var k = 0; k < this.CurrentPoints.length - 1; k++) {
        var p1 = this.CurrentPoints[k];
        var p2 = this.CurrentPoints[k + 1];
        var cp1 = {
          x: p1.ocx,
          y: p1.ocy
        };
        var cp2 = {
          x: p2.icx,
          y: p2.icy
        };

        var set = {};
        var step = p2.x - p1.x;
        var stepValue = 1 / step;
        var currentStep = 0;
        for (var i = 0; i < step; i++) {
          var limitCount = 0;
          var t = i * stepValue + currentStep;
          var x = p1.x + i;
          var p = getBezierPointFromT(x, t, t + stepValue, p1, cp1, cp2, p2);
          while (!p) {
            limitCount++;
            currentStep += stepValue;
            t = i * stepValue + currentStep;
            if (t > 1) t = 1;
            p = getBezierPointFromT(x, t, t + stepValue, p1, cp1, cp2, p2);
            if (limitCount > 20 && !p) p = { x: x, y: set[x - 1].y };
          }
          set[p.x] = p;
        }
        set[p2.x] = p2;
        sets.push(set);
      }

      function getBezierPointFromT(checkX, startT, endT, p1, cp1, cp2, p2) {
        checkX = Math.floor(checkX);
        var stepT = 10;
        var stepTValue = (endT - startT) / stepT;
        for (var j = 0; j < 10; j++) {
          var innerT = startT + j * stepTValue;
          var pT = that.threeBezier(innerT, p1, cp1, cp2, p2);
          var resultX = Math.floor(pT.x);
          if (resultX === checkX) {
            return pT;
          } else if (resultX > checkX) {
            return getBezierPointFromT(checkX, 2 * startT - endT, innerT, p1, cp1, cp2, p2);
          }
        }
        return false;
      }
      this.lineSet = sets;
      return sets;
    },

    /**
     * @desc 三阶贝塞尔
     * @param {number} t 当前百分比
     * @param {Array} p1 起点坐标
     * @param {Array} p2 终点坐标
     * @param {Array} cp1 控制点1
     * @param {Array} cp2 控制点2
     */
    threeBezier: function threeBezier(t, p1, cp1, cp2, p2) {
      // const [x1, y1] = p1;
      // const [x2, y2] = p2;
      // const [cx1, cy1] = cp1;
      // const [cx2, cy2] = cp2;
      var x1 = p1.x;
      var y1 = p1.y;
      var x2 = p2.x;
      var y2 = p2.y;
      var cx1 = cp1.x;
      var cy1 = cp1.y;
      var cx2 = cp2.x;
      var cy2 = cp2.y;

      var x = x1 * Math.pow(1 - t, 3) + 3 * cx1 * t * Math.pow(1 - t, 2) + 3 * cx2 * Math.pow(t, 2) * (1 - t) + x2 * Math.pow(t, 3);
      var y = y1 * Math.pow(1 - t, 3) + 3 * cy1 * t * Math.pow(1 - t, 2) + 3 * cy2 * Math.pow(t, 2) * (1 - t) + y2 * Math.pow(t, 3);
      return { x: Math.floor(x), y: Math.floor(y) };
    }
  })
};